// removed by extract-text-webpack-plugin
module.exports = {"content":"_20iKaXmLJkzb5fFvmAILW6","file":"_2vTR1OKcNPzGyhKVZvZm2W"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/organisms/Timeline/Containers/BoxAttachment/style.css
// module id = 636
// module chunks = 38